import React, {useEffect, useState} from 'react';
import {useParams} from "react-router-dom";
import {getTask} from "../../services/CourseRepository";
import {useError} from "../../hooks/useError";
import ComplexParser from "../course/ComplexParser";
import {CompositeTask} from "../course/CompositeTask";
import {Subtask} from "../course/Subtask";
import Header from "../../components/navigation/Header";

export function TaskViewer() {

    const [task, setTask] = useState();
    const params = useParams();
    const {setErrorMessage} = useError();


    useEffect(() => {
        getTask(params.id, setErrorMessage).then(response => {
            console.log(response)
            setTask(response)
        })
            .catch(e => console.error(e))
    }, []);


    if(task != null) {
        const parser = new ComplexParser();
        const parsedContent = parser.parseContent(task.description.value);


        return (
            <div>
                <Header/>
                <div className={"container pt-5"}>
                    <h2>Oppgave</h2>
                    {parsedContent}

                    {task.subtasks.map((item, idx) => (
                        <div className={"p-3 row mb-3 border-bottom"}>
                            <span className={"fw-bold col-1"}>{idx+1}. </span>

                            <div className={"col"}>
                                {parser.parseContent(item.subtask.value)}
                                <div className={"border border-dark p-2"}>
                                    <h3>Løsning</h3>
                                    {parser.parseContent(item.solution.value)}
                                </div>
                            </div>
                        </div>
                    ))}

                </div>
            </div>
        );

    }

}